<template>
  <div class="title">
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>休息日列表</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align:left">
        <el-col :span="24">
          <el-form :model="searchForm" :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-date-picker
                size="small"
                v-model="searchForm.value"
                align="left"
                type="date"
                placeholder="选择日期"
                @change="change"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="getSchedulingInfoList">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="dialogVisible=true">添加休息日</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <div class="container_table">
        <el-table
          :data="tableData"
          size="small"
          :default-sort="{prop: 'date', order: 'descending'}"
        >
          <el-table-column prop="RelaxDate" label="休息日"></el-table-column>
          <el-table-column prop="Month" label="月份"></el-table-column>
          <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
          style="float:right"
        ></el-pagination>
      </div>
      <el-dialog
        class="dialog_size"
        title="添加休息日"
        :visible.sync="dialogVisible"
        width="25%"
        :before-close="handleClose"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="休息日" prop="date1" class="is-required">
            <el-date-picker v-model="ruleForm.date1" align="left" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="submitForm('ruleForm')" plain>立即创建</el-button>
            <el-button size="small" @click="resetForm('ruleForm')" plain>重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import {
  GetSchedulingInfoList,
  AddSchedulingInfo
} from "../../until/ZeusApiSDK/Logic/SchedulingLogic";
export default {
  name: "list11",
  data() {
    return {
      value: "",
      total: 0, //a分页总条数
      tableData: [], //展示的休息日数据
      ruleForm: {
        date1: ""
      },
      searchForm:{value:""},
      rules: {
        date1: [{ required: true, message: "请选择日期", trigger: "change" }]
      },
      input: "",
      dialogVisible: false,
      c: "",
      currentPage: 1, //默认开始页面
      istag: true,
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0
    };
  },
  methods: {
    //时间转换 不够10 添加0
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    //刷新
    Refresh:function(){
      this.getSchedulingInfoList();
    },
    getSchedulingInfoList: async function() {
      //转换工作经历开始时间
      if (this.searchForm.value != "" && this.searchForm.value != null) {
        const beginDate = new Date(this.searchForm.value);
        const resbeginDate =
          beginDate.getFullYear() +
          "-" +
          this.p(beginDate.getMonth() + 1) +
          "-" +
          this.p(beginDate.getDate());
        this.value = resbeginDate;
        var data = {
          searchTime: this.value,
          p: this.currentPage,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex
        };
      } else {
        var data = {
          searchTime: null,
          p: this.currentPage,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex
        };
      }
      await GetSchedulingInfoList(data).then(res => {
        if (res.TotalCount > 0) {
          this.tableData = res.List;
          this.totalCount = res.TotalCount;
        } else {
          this.tableData = null;
          this.totalCount = 0;
        }
      });
    },

    OperAddSchedulingInfo: async function() {
      //添加数据
      if (this.ruleForm.date1 != "" && this.ruleForm.date1 != null) {
        const beginDate = new Date(this.ruleForm.date1);
        const resbeginDate =
          beginDate.getFullYear() +
          "-" +
          this.p(beginDate.getMonth() + 1) +
          "-" +
          this.p(beginDate.getDate());
        this.ruleForm.date1 = resbeginDate;
      }
      await AddSchedulingInfo(this.ruleForm.date1).then(res => {
        if (res.Result == 1) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.getSchedulingInfoList();
        } else {
          this.$message.error(res.Message);
        }
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.dialogVisible = false;
          //拿数据保存数据库
          this.OperAddSchedulingInfo();
        } else {
          this.dialogVisible = true;
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    change: function() {
      //this.pageSize = 10;
      this.getSchedulingInfoList();
    },
    // current_change: function(currentPage) {
    //   this.currentPage = currentPage;
    //   this.getSchedulingInfoList();
    // },
    handleSizeChange(val) {
      this.pageSize = val;
      //this.GetSysUserPageList();
      this.getSchedulingInfoList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      // this.GetSysUserPageList();
      this.getSchedulingInfoList();
    }
  },
  //页面进入加载事件
  created: function() {
    //获取休息日数据
    this.getSchedulingInfoList();
  }
};
</script>
<style lang="less" scoped>
.fl {
  float: right;
  margin-right: 20px;
}
.fy {
  text-align: center;
  margin-top: 30px;
}
.title {
  height: 100%;
}
</style>